import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../../assets/website_logo.png";
import { Box, IconButton, SwipeableDrawer, useMediaQuery } from "@mui/material";
import {
  Close,
  LocationOn,
  Menu,
  Phone,
  ArrowForward,
} from "@mui/icons-material";
import { CONTACT_INFO } from "consts";
import { motion } from "framer-motion";
import "./NavBar.css";

const NavBar = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:900px)");

  const isActive = (path) => location.pathname === path;

  const imageSize = isMobile
    ? { height: "80px", width: "80px" }
    : { height: "100px", width: "100px" };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsDrawerOpen(open);
  };

  const navLinks = [
    { to: "/", label: "Accueil" },
    { to: "/reserver", label: "Réserver" },
    { to: "/faq", label: "FAQ" },
    { to: "/tarifs", label: "Tarifs" },
    { to: "/galerie", label: "Galerie" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="logo">
            <img
              src={logo}
              alt="Le Corps de Ferme Logo"
              style={{
                objectFit: "contain",
                ...imageSize,
              }}
            />
          </Link>

          {/* Desktop Navigation */}
          {!isMobile && (
            <div className="desktop-nav">
              <div className="nav-links">
                {navLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className={`nav-link ${isActive(link.to) ? "active" : ""}`}
                  >
                    {link.label}
                  </Link>
                ))}
              </div>

              {/* Contact Information */}

              <div className="contact-info">
                {/* <div className="contact-item">
                  <LocationOn className="contact-icon" />
                  <div className="contact-text">
                    <span className="contact-label">ADDRESS</span>
                    <span className="contact-value">
                      {CONTACT_INFO.address}
                    </span>
                  </div>
                </div> */}

                {/* <div className="contact-item">
                  <Phone className="contact-icon" />
                  <div className="contact-text">
                    <span className="contact-label">APPELEZ NOUS !</span>
                    <a
                      href={`tel:${CONTACT_INFO.phone}`}
                      className="phone-number"
                    >
                      {CONTACT_INFO.phone}
                    </a>
                  </div>
                </div> */}
              </div>
            </div>
          )}

          {/* Mobile Menu Button */}
          {isMobile && (
            <IconButton
              className="menu-button"
              onClick={toggleDrawer(true)}
              aria-label="menu"
            >
              <Menu />
            </IconButton>
          )}
        </div>
      </nav>

      {/* Mobile Swipeable Drawer */}
      <SwipeableDrawer
        anchor="right"
        open={isDrawerOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        className="drawer"
        classes={{
          paper: "drawer-paper",
        }}
      >
        <Box className="drawer-content">
          <Box className="drawer-header">
            <img
              src={logo}
              alt="Le Corps de Ferme Logo"
              className="drawer-logo"
              style={{ height: "70px", width: "70px" }}
            />
            <IconButton onClick={toggleDrawer(false)} className="close-button">
              <Close />
            </IconButton>
          </Box>

          <Box className="drawer-links">
            {navLinks.map((link, index) => (
              <motion.div
                key={link.to}
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.1 * index, duration: 0.3 }}
              >
                <Link
                  to={link.to}
                  onClick={toggleDrawer(false)}
                  className={`drawer-link ${isActive(link.to) ? "active" : ""}`}
                >
                  <span>{link.label}</span>
                  <ArrowForward className="link-arrow" />
                </Link>
              </motion.div>
            ))}
          </Box>

          <Box className="drawer-footer">
            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 }}
              className="drawer-contact"
            >
              <LocationOn className="drawer-contact-icon" />
              <div className="drawer-contact-text">
                <span className="drawer-contact-label">ADDRESS</span>
                <span className="drawer-contact-value">
                  {CONTACT_INFO.address}
                </span>
              </div>
            </motion.div> */}

            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7 }}
              className="drawer-contact"
            >
              <Phone className="drawer-contact-icon" />
              <div className="drawer-contact-text">
                <span className="drawer-contact-label">APPELEZ NOUS !</span>
                <a
                  href={`tel:${CONTACT_INFO.phone}`}
                  className="drawer-phone-number"
                >
                  {CONTACT_INFO.phone}
                </a>
              </div>
            </motion.div> */}
          </Box>
        </Box>
      </SwipeableDrawer>
    </>
  );
};

export default NavBar;
